import { render, staticRenderFns } from "./MessageTemplatePopup.vue?vue&type=template&id=099e74a2"
import script from "./MessageTemplatePopup.vue?vue&type=script&lang=js"
export * from "./MessageTemplatePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports